module.exports = [{
      plugin: require('../node_modules/gatsby-plugin-manifest/gatsby-browser.js'),
      options: {"plugins":[],"name":"mockyeah","short_name":"mockyeah","start_url":"/","background_color":"#9014fe","theme_color":"#9014fe","display":"minimal-ui","icon":"src/images/logo/mockyeah.png","cache_busting_mode":"query","include_favicon":true,"legacy":true,"theme_color_in_head":true,"cacheDigest":"d1e56e1f1cfe4a03cd14178fcc638e3c"},
    },{
      plugin: require('../node_modules/gatsby-remark-autolink-headers/gatsby-browser.js'),
      options: {"plugins":[]},
    },{
      plugin: require('../node_modules/gatsby-remark-images/gatsby-browser.js'),
      options: {"plugins":[]},
    },{
      plugin: require('../node_modules/gatsby-plugin-mdx/gatsby-browser.js'),
      options: {"plugins":[],"defaultLayouts":{"default":"/opt/build/repo/packages/mockyeah-docs/src/layouts/default.js"},"gatsbyRemarkPlugins":["gatsby-remark-autolink-headers","gatsby-remark-prismjs","gatsby-remark-images","gatsby-remark-copy-linked-files"]},
    },{
      plugin: require('../node_modules/gatsby-plugin-catch-links/gatsby-browser.js'),
      options: {"plugins":[]},
    },{
      plugin: require('../gatsby-browser.js'),
      options: {"plugins":[]},
    }]
